import loadImage from "blueimp-load-image";
// polyfill .toBlob for older browsers
import "blueimp-canvas-to-blob/js/canvas-to-blob";
const MAX_IMG_WIDTH = 2000;
const MAX_IMG_HEIGHT = 2000;
const IMG_QUALITY = 0.8;
const IMG_MIME_TYPE = "image/jpeg";
// Convert to blob representation
// Compress image due to blob operation
// Add metadata orientation
// Fix due to ipad
const convertToBlobFixRotationAndCompress = async (file) => {
    return new Promise(resolve => {
        loadImage(file, img => {
            img.toBlob(blob => {
                resolve(blob);
            }, IMG_MIME_TYPE, IMG_QUALITY);
        }, {
            orientation: true,
            maxWidth: MAX_IMG_WIDTH,
            maxHeight: MAX_IMG_HEIGHT,
            canvas: true,
        });
    });
};
export const convertFilesToBlobFixRotationAndCompress = async (arrayOfFiles) => {
    const promises = arrayOfFiles.map(file => convertToBlobFixRotationAndCompress(file));
    return Promise.all(promises);
};
